import api from './fetch'

function getData (params, success, failure) {
  const outputRes = {
    success: true
  }
  api.get('data.json', params, res => {
    outputRes.data = dataProcess(res.data, params)
    success(outputRes)
  }, failure)
}

function dataProcess (data, params) {
  // type === 0  全文搜索
  // type === 1  标题搜索
  // type === 2  相关领域搜索
  // type === 3  标签搜索
  // type === 4  作者搜索
  // type === 5  推荐者搜索
  // type === 99  key值搜索
  if (!params || params.type === undefined || !params.text) { return }

  const outputData = []
  switch (params.type) {
    case 0:
      // 全文搜索
      data.forEach(item => {
        const flag =
          item.lectureInfo.lectureName.indexOf(params.text) !== -1 ||
          strArrContains(item.lectureInfo.associatedField, params.text) ||
          strArrContains(item.tags, params.text) ||
          item.lectureInfo.lecturer.indexOf(params.text) !== -1 ||
          item.recommenderInfo.id.indexOf(params.text) !== -1
        if (flag) {
          outputData.push(item)
        }
      })
      break
    case 1:
      // 标题搜索
      data.forEach(item => {
        const flag = item.lectureInfo.lectureName.indexOf(params.text) !== -1
        if (flag) {
          outputData.push(item)
        }
      })
      break
    case 2:
      // 相关领域搜索
      data.forEach(item => {
        const flag = strArrContains(item.lectureInfo.associatedField, params.text)
        if (flag) {
          outputData.push(item)
        }
      })
      break
    case 3:
      // 标签搜索
      data.forEach(item => {
        const flag = strArrContains(item.tags, params.text)
        if (flag) {
          outputData.push(item)
        }
      })
      break
    case 4:
      // 作者搜索
      data.forEach(item => {
        const flag = item.lectureInfo.lecturer.indexOf(params.text) !== -1
        if (flag) {
          outputData.push(item)
        }
      })
      break
    case 5:
      // 推荐者搜索
      data.forEach(item => {
        const flag = item.recommenderInfo.id.indexOf(params.text) !== -1
        if (flag) {
          outputData.push(item)
        }
      })
      break
    case 99:
      // key值搜索
      for (const i in data) {
        if (data[i].key === params.text) {
          outputData.push(data[i])
          break
        }
      }
  }
  return outputData
}

function strArrContains (poolArr, str) {
  if (!poolArr) { return false }
  if (poolArr.length < 1) { return false }
  for (let i = 0; i < poolArr.length; i++) {
    if (poolArr[i].indexOf(str) !== -1) {
      return true
    }
  }
  return false
}

export default {
  getData
}
